/* global gform, ajax_object */
// Import everything from autoload folder
import './autoload/_bootstrap.js'; import './autoload/ada-compliance.js'; // eslint-disable-line

// Import local dependencies
import './plugins/lazyload';
import './plugins/modernizr.min';
import 'slick-carousel';
import 'jquery-match-height';
import objectFitImages from 'object-fit-images';
import Cookies from 'js-cookie';
// import '@fancyapps/fancybox/dist/jquery.fancybox.min';
// import { jarallax, jarallaxElement } from 'jarallax';
// import ScrollOut from 'scroll-out';

/**
 * Custom select dropdown
 */
jQuery.fn.scrollTo = function (elem) {
  $(this).scrollTop(
    $(this).scrollTop() - $(this).offset().top + $(elem).offset().top
  );
  return this;
};

function initCustomSelect(repeater) {
  $(document)
    .find('select')
    .each(function () {
      var $this = $(this),
        selectClasses = $this.attr('class'),
        numberOfOptions = $(this).children('option').length;
      if (repeater === true) {
        if (
          $this.parent('.select').length &&
          $this.parents('.gfield_repeater_item').length === 0
        ) {
          return;
        }
      } else {
        if ($this.parent('.select').length) {
          return;
        }
      }
      let $styledSelect;
      let $list;
      if (repeater !== true) {
        $this
          .addClass('hide')
          .wrap('<div class="select"></div>')
          .after('<div class="select-styled"></div>');

        $styledSelect = $this.next('div.select-styled');
        $styledSelect
          .text($this.children('option:selected').text())
          .addClass(selectClasses);

        $list = $('<ul />', {
          class: 'select-options',
        }).insertAfter($styledSelect);

        for (var i = 0; i < numberOfOptions; i++) {
          $('<li />', {
            text: $this.children('option').eq(i).text(),
            rel: $this.children('option').eq(i).val(),
          }).appendTo($list);
        }
      } else {
        $styledSelect = $this.next('div.select-styled');
        $list = $this.next('div.select-styled').next('.select-options');
      }

      let checkEvents =
        Object.keys($._data($styledSelect.get(0))).length === 0 &&
        Object.getPrototypeOf($._data($styledSelect.get(0))) ===
          Object.prototype;
      if (checkEvents) {
        $styledSelect.on('click', function (e) {
          e.stopPropagation();
          $('div.select-styled.active')
            .not(this)
            .each(function () {
              $(this).removeClass('active').next('ul.select-options').hide();
            });
          $(this).toggleClass('active').next('ul.select-options').toggle();
          let currVal = $(this).siblings('select').val();
          // console.log($(this).siblings('.select-options'));
          $(this)
            .siblings('.select-options')
            .scrollTo('li[rel="' + currVal + '"]');
        });

        $list.children('li').on('click', function (e) {
          e.stopPropagation();
          $styledSelect
            .text($(this).text())
            .removeClass('active')
            .next('.select-options')
            .hide();
          $this.val($(this).attr('rel')).trigger('change');
        });
        $(document).on('click', function () {
          if ($styledSelect.hasClass('active')) {
            $styledSelect.removeClass('active');
            $list.hide();
          }
        });
        if (repeater === true) {
          $list.children('li').first().trigger('click');
        } else {
          $list
            .children('li[rel="' + $list.siblings('select').val() + '"]')
            .trigger('click');
        }
      }
    });
}

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function () {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function () {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function () {
  initCustomSelect();
  if ($('body').hasClass('page-template-template-booking')) {
    let passengers = $('.booking').data('passengers'),
      time = $('.booking').data('time'),
      date = $('.booking').data('date'),
      to = $('.booking').data('to'),
      from = $('.booking').data('from'),
      hometo = $('.booking').data('home-to'),
      homefrom = $('.booking').data('home-from');
    $(
      '.gfield_repeater_items .gfield_repeater_item:eq(0) .gfield_repeater_cell:eq(0)'
    )
      .find('input')
      .val(from)
      .addClass('clear-block')
      .attr('data-id', homefrom);
    Cookies.set(
      $(
        '.gfield_repeater_items .gfield_repeater_item:eq(0) .gfield_repeater_cell:eq(0)'
      )
        .find('input')
        .attr('id'),
      $(
        '.gfield_repeater_items .gfield_repeater_item:eq(0) .gfield_repeater_cell:eq(0)'
      )
        .find('input')
        .attr('data-id')
    );
    $(
      '.gfield_repeater_items .gfield_repeater_item:eq(0) .gfield_repeater_cell:eq(1)'
    )
      .find('input')
      .val(to)
      .addClass('clear-block')
      .attr('data-id', hometo);
    Cookies.set(
      $(
        '.gfield_repeater_items .gfield_repeater_item:eq(0) .gfield_repeater_cell:eq(1)'
      )
        .find('input')
        .attr('id'),
      $(
        '.gfield_repeater_items .gfield_repeater_item:eq(0) .gfield_repeater_cell:eq(1)'
      )
        .find('input')
        .attr('data-id')
    );
    $(
      '.gfield_repeater_items .gfield_repeater_item:eq(0) .gfield_repeater_cell:eq(2)'
    )
      .find('input')
      .val(date);
    $(
      '.gfield_repeater_items .gfield_repeater_item:eq(0) .gfield_repeater_cell:eq(3)'
    )
      .find('li[rel="' + time + '"]')
      .trigger('click');
    $(
      '.gfield_repeater_items .gfield_repeater_item:eq(0) .gfield_repeater_cell:eq(4)'
    )
      .find('li[rel="' + passengers + '"]')
      .trigger('click');

    setTimeout(function () {
      $(
        '.gfield_repeater_item .gfield_repeater_cell .ginput_container_text input'
      ).each(function () {
        if ($(this).val().length > 0) {
          $(this).siblings('.removeClick').css('display', 'flex');
        }
      });
    }, 500);
  }
  jQuery(document).on('gform_post_render', function () {
    // console.log(event);
    // console.log(form_id);
    // console.log(current_page);
    initCustomSelect();
    if ($('.gfield_repeater_buttons').length) {
      let roundtripText = $('.js-form-wrap').data('roundtrip-text');
      let roundtrip =
        '<button type="button" class="add_repeater_item add_repeater_item_text roundtrip_repeater_item" onclick="gformAddRepeaterItem(this)" onkeypress="gformAddRepeaterItem(this)">' +
        roundtripText +
        '</button>';
      $(roundtrip).prependTo('.gfield_repeater_buttons');
    }
    $(document).on('click', '.roundtrip_repeater_item', function () {
      let $this = $(this);
      setTimeout(function () {
        let passengers = $(
            '.gfield_repeater_items .gfield_repeater_item:eq(0) .gfield_repeater_cell:eq(4)'
          )
            .find('select')
            .val(),
          time = $(
            '.gfield_repeater_items .gfield_repeater_item:eq(0) .gfield_repeater_cell:eq(3)'
          )
            .find('select')
            .val(),
          date = $(
            '.gfield_repeater_items .gfield_repeater_item:eq(0) .gfield_repeater_cell:eq(2)'
          )
            .find('input')
            .val(),
          to = $(
            '.gfield_repeater_items .gfield_repeater_item:eq(0) .gfield_repeater_cell:eq(1)'
          )
            .find('input')
            .val(),
          from = $(
            '.gfield_repeater_items .gfield_repeater_item:eq(0) .gfield_repeater_cell:eq(0)'
          )
            .find('input')
            .val(),
          toFlag = $(
            '.gfield_repeater_items .gfield_repeater_item:eq(0) .gfield_repeater_cell:eq(1)'
          )
            .find('input')
            .data('id'),
          fromFlag = $(
            '.gfield_repeater_items .gfield_repeater_item:eq(0) .gfield_repeater_cell:eq(0)'
          )
            .find('input')
            .data('id');
        $(
          '.gfield_repeater_items .gfield_repeater_item:eq(1) .gfield_repeater_cell:eq(0)'
        )
          .find('input')
          .val(to)
          .addClass('clear-block')
          .attr('data-id', toFlag);
        Cookies.set(
          $(
            '.gfield_repeater_items .gfield_repeater_item:eq(1) .gfield_repeater_cell:eq(0)'
          )
            .find('input')
            .attr('id'),
          $(
            '.gfield_repeater_items .gfield_repeater_item:eq(1) .gfield_repeater_cell:eq(0)'
          )
            .find('input')
            .attr('data-id')
        );
        $(
          '.gfield_repeater_items .gfield_repeater_item:eq(1) .gfield_repeater_cell:eq(1)'
        )
          .find('input')
          .val(from)
          .addClass('clear-block')
          .attr('data-id', fromFlag);
        Cookies.set(
          $(
            '.gfield_repeater_items .gfield_repeater_item:eq(1) .gfield_repeater_cell:eq(1)'
          )
            .find('input')
            .attr('id'),
          $(
            '.gfield_repeater_items .gfield_repeater_item:eq(1) .gfield_repeater_cell:eq(1)'
          )
            .find('input')
            .attr('data-id')
        );

        let nextday = new Date(date);
        // let tomorrow = new Date();
        if (Object.prototype.toString.call(date) === '[object Date]') {
          // it is a date
          if (isNaN(date)) {
            // d.getTime() or d.valueOf() will also work
          } else {
            nextday.setDate(nextday.getTime() + 86400000);
          }
        } else {
          let dateParts = date.split('/');
          let validDate = new Date(
            +dateParts[2],
            dateParts[1] - 1,
            +dateParts[0]
          );
          validDate.setDate(validDate.getDate() + 1);
          // console.log(validDate);
          // console.log(validDate.getDate() + 1);
          nextday =
            validDate.getDate() +
            '/' +
            (validDate.getMonth() + 1) +
            '/' +
            validDate.getFullYear();
        }
        $(
          '.gfield_repeater_items .gfield_repeater_item:eq(1) .gfield_repeater_cell:eq(2)'
        )
          .find('input')
          .val(nextday);
        $(
          '.gfield_repeater_items .gfield_repeater_item:eq(1) .gfield_repeater_cell:eq(3)'
        )
          .find('li[rel="' + time + '"]')
          .trigger('click');
        $(
          '.gfield_repeater_items .gfield_repeater_item:eq(1) .gfield_repeater_cell:eq(4)'
        )
          .find('li[rel="' + passengers + '"]')
          .trigger('click');

        let currTime = new Date().getHours();
        // console.log(currentTime);
        if (currTime >= 6 && currTime < 12) {
          $this
            .parents('.gfield_repeater_items')
            .find('.gfield_repeater_item:last-child')
            .find('.gfield_repeater_cell:eq(3)')
            .find('li[rel="11:00"]')
            .trigger('click');
        } else if (currTime >= 12 && currTime < 16) {
          $this
            .parents('.gfield_repeater_items')
            .find('.gfield_repeater_item:last-child')
            .find('.gfield_repeater_cell:eq(3)')
            .find('li[rel="15:00"]')
            .trigger('click');
        } else if (currTime >= 16 && currTime < 24) {
          $this
            .parents('.gfield_repeater_items')
            .find('.gfield_repeater_item:last-child')
            .find('.gfield_repeater_cell:eq(3)')
            .find('li[rel="19:00"]')
            .trigger('click');
        } else if (currentTime >= 24 && currentTime < 6) {
          $this
            .parents('.gfield_repeater_items')
            .find('.gfield_repeater_item:last-child')
            .find('.gfield_repeater_cell:eq(3)')
            .find('li[rel="09:30"]')
            .trigger('click');
        }
      }, 500);
      $('.booking-form').addClass('roundtrip');
    });
    $(document).on(
      'click',
      '.add_repeater_item:not(.roundtrip_repeater_item)',
      function () {
        let $this = $(this);
        let toFlag = $(this)
            .parents('.gfield_repeater_item')
            .find('.gfield_repeater_cell:eq(1)')
            .find('input')
            .data('id'),
          to = $(this)
            .parents('.gfield_repeater_item')
            .find('.gfield_repeater_cell:eq(1)')
            .find('input')
            .val();
        setTimeout(function () {
          console.log(
            $this
              .parents('.gfield_repeater_items')
              .find('.gfield_repeater_item:last-child')
          );
          $this
            .parents('.gfield_repeater_items')
            .find('.gfield_repeater_item:last-child')
            .find('.gfield_repeater_cell:eq(0)')
            .find('input')
            .val(to)
            .addClass('clear-block')
            .attr('data-id', toFlag);
          Cookies.set(
            $this
              .parents('.gfield_repeater_items')
              .find('.gfield_repeater_item:last-child')
              .find('.gfield_repeater_cell:eq(0)')
              .find('input')
              .attr('id'),
            $this
              .parents('.gfield_repeater_items')
              .find('.gfield_repeater_item:last-child')
              .find('.gfield_repeater_cell:eq(0)')
              .find('input')
              .attr('data-id')
          );
          let currTime = new Date().getHours();
          // console.log(currentTime);
          if (currTime >= 6 && currTime < 12) {
            $this
              .parents('.gfield_repeater_items')
              .find('.gfield_repeater_item:last-child')
              .find('.gfield_repeater_cell:eq(3)')
              .find('li[rel="11:00"]')
              .trigger('click');
          } else if (currTime >= 12 && currTime < 16) {
            $this
              .parents('.gfield_repeater_items')
              .find('.gfield_repeater_item:last-child')
              .find('.gfield_repeater_cell:eq(3)')
              .find('li[rel="15:00"]')
              .trigger('click');
          } else if (currTime >= 16 && currTime < 24) {
            $this
              .parents('.gfield_repeater_items')
              .find('.gfield_repeater_item:last-child')
              .find('.gfield_repeater_cell:eq(3)')
              .find('li[rel="19:00"]')
              .trigger('click');
          } else if (currentTime >= 24 && currentTime < 6) {
            $this
              .parents('.gfield_repeater_items')
              .find('.gfield_repeater_item:last-child')
              .find('.gfield_repeater_cell:eq(3)')
              .find('li[rel="09:30"]')
              .trigger('click');
          }
        }, 500);
        setTimeout(function () {
          $(
            '.gfield_repeater_item .gfield_repeater_cell .ginput_container_text input'
          ).each(function () {
            if ($(this).val().length > 0) {
              $(this).siblings('.removeClick').css('display', 'flex');
            }
          });
        }, 500);
      }
    );
    $(document).on('click', '.add_repeater_item', function () {
      // if ($('.gfield_repeater_items').children().length <= 1) {
      $('.roundtrip_repeater_item').addClass('roundtrip-hide');
      // }
    });
    $(document).on('click', '.remove_repeater_item', function () {
      if ($('.gfield_repeater_items').children().length <= 1) {
        $('.booking-form').removeClass('roundtrip');
        $('.roundtrip_repeater_item').removeClass('roundtrip-hide');
      }
    });
  });
  // if ($('body').hasClass('page-template-template-home')) {
  $('.js-round-trip').on('click', function () {
    Cookies.set('home-round-trip', 'true');
    $('.home-contact-form .gform_button').trigger('click');
  });
  $('.js-add-flight').on('click', function () {
    Cookies.set('home-add-flight', 'true');
    $('.home-contact-form .gform_button').trigger('click');
  });
  let currentTime = new Date().getHours();
  // console.log(currentTime);
  if (
    $('.booking').data('date') == '' ||
    $('body').hasClass('page-template-template-home')
  ) {
    if (currentTime >= 6 && currentTime < 12) {
      $('li[rel="11:00"]').trigger('click');
    } else if (currentTime >= 12 && currentTime < 16) {
      $('li[rel="15:00"]').trigger('click');
    } else if (currentTime >= 16 && currentTime < 24) {
      $('li[rel="19:00"]').trigger('click');
    } else if (currentTime >= 24 && currentTime < 6) {
      $('li[rel="09:30"]').trigger('click');
    }
  }
  // }
  if ($('body').hasClass('page-template-template-booking')) {
    if (Cookies.get('home-round-trip') == 'true') {
      setTimeout(function () {
        $('.roundtrip_repeater_item').trigger('click');
      }, 300);
    } else if (Cookies.get('home-add-flight') == 'true') {
      setTimeout(function () {
        $('.add_repeater_item:not(.roundtrip_repeater_item)').trigger('click');
      }, 300);
    }
    Cookies.remove('home-round-trip');
    Cookies.remove('home-add-flight');
  }
  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  /**
   * Add fancybox to images
   */
  // $('.gallery-item')
  //   .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
  //   .attr('rel', 'gallery')
  //   .attr('data-fancybox', 'gallery');
  // $(
  //   '.fancybox, a[rel*="album"], a[href$="jpg"], a[href$="png"], a[href$="gif"]'
  // ).fancybox({
  //   minHeight: 0,
  //   helpers: {
  //     overlay: {
  //       locked: false,
  //     },
  //   },
  // });

  /**
   * Init parallax
   */
  // jarallaxElement();
  // jarallax(document.querySelectorAll('.jarallax'), {
  //   speed: 0.5,
  // });

  /**
   * Detect element appearance in viewport
   */
  // ScrollOut({
  //   offset: function() {
  //     return window.innerHeight - 200;
  //   },
  //   once: true,
  //   onShown: function(element) {
  //     if ($(element).is('.ease-order')) {
  //       $(element)
  //         .find('.ease-order__item')
  //         .each(function(i) {
  //           let $this = $(this);
  //           $(this).attr('data-scroll', '');
  //           window.setTimeout(function() {
  //             $this.attr('data-scroll', 'in');
  //           }, 300 * i);
  //         });
  //     }
  //   },
  // });

  /**
   * Remove placeholder on click
   */
  // const removeFieldPlaceholder = () => {
  //   $('input, textarea').each((i, el) => {
  //     $(el)
  //       .data('holder', $(el).attr('placeholder'))
  //       .on('focusin', () => {
  //         $(el).attr('placeholder', '');
  //       })
  //       .on('focusout', () => {
  //         $(el).attr('placeholder', $(el).data('holder'));
  //       });
  //   });
  // };
  //
  // removeFieldPlaceholder();
  //
  // $(document).on('gform_post_render', () => {
  //   removeFieldPlaceholder();
  // });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  // $(document).on('gform_confirmation_loaded', function (event, formId) {
  //   let $target = $('#gform_confirmation_wrapper_' + formId);
  //   if ($target.length) {
  //     $('html, body').animate({ scrollTop: $target.offset().top - 50 }, 500);
  //     return false;
  //   }
  // });
  /**
   * Scroll to top after Gravity Form submit
   */
  $(document).on('gform_confirmation_loaded', function (event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: 0 }, 500);
      return false;
    }
  });
  /**
   * Scroll to top of the page after clicking on gravity from next page button
   */
  $(document).on('click', '.gform_next_button', function () {
    $(window).scrollTop(0);
  });
  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  /**
   * Add `is-active` class to menu-icon button on Responsive menu toggle
   * And remove it on breakpoint change
   */
  $(window)
    .on('toggled.zf.responsiveToggle', function () {
      $('.menu-icon').toggleClass('is-active');
    })
    .on('changed.zf.mediaquery', function () {
      $('.menu-icon').removeClass('is-active');
    });

  /**
   * Close responsive menu on orientation change
   */
  $(window).on('orientationchange', function () {
    setTimeout(function () {
      if ($('.menu-icon').hasClass('is-active') && window.innerWidth < 641) {
        // TODO: replace with bootstrap toggle
        // $('[data-responsive-toggle="main-menu"]').foundation('toggleMenu');
      }
    }, 200);
  });

  resizeVideo();

  // Close element on click outside it
  $('.wpml-custom-switcher').on('click', function () {
    $('.wpml-custom-list').toggleClass('active');
  });
  $(document).click(function (e) {
    // Check if required element is visible
    if ($('.wpml-custom-list.active').length) {
      // Check if we clicked not on dropdown children or not on dropdown itself
      if (
        !$(e.target).closest('.wpml-custom-wrapper').length &&
        !$(e.target).hasClass('wpml-custom-wrapper')
      ) {
        // Hide required element
        $('.wpml-custom-list').removeClass('active');
        e.stopPropagation();
      }
    }
  });
  $(document).click(function (event) {
    var clickover = $(event.target);
    var _opened = $('.navbar-collapse').hasClass('show');
    if (_opened === true && !clickover.hasClass('navbar-toggler')) {
      $('.navbar-toggler').click();
    }
  });
  $(document).click(function (e) {
    // Check if required element is visible
    if ($('.search-results').length) {
      // Check if we clicked not on dropdown children or not on dropdown itself
      if (
        !$(e.target).closest('.search-results').length &&
        !$(e.target).hasClass('search-results')
      ) {
        // Hide required element
        $('.search-results').hide();
        e.stopPropagation();
      }
    }
  });
  $(document).click(function (e) {
    if (
      !$(e.target).hasClass('team-members__content') &&
      !$(e.target).closest('.team-members__content').length &&
      !$(e.target).closest('.team-members__block').length &&
      $('.team-members__block').length
    ) {
      $('.collapse').collapse('hide');
      $('.team-members__block').removeClass('opaque');
      $('.team-members__block a').removeClass('active');
    }
  });
  $(document).click(function (e) {
    if (
      !$(e.target).hasClass('js-destinations__bottom-content') &&
      !$(e.target).closest('.js-destinations__bottom-content').length &&
      !$(e.target).closest('.js-destinations__bottom-block').length &&
      $('.js-destinations__bottom-block').length
    ) {
      $('.collapse').collapse('hide');
      $('.js-destinations__bottom-block').removeClass('opaque');
      $('.js-destinations__bottom-block a').removeClass('active');
    }
  });
  $(document).click(function (e) {
    if (
      !$(e.target).hasClass('custom-validation') &&
      !$(e.target).closest('.custom-validation').length &&
      $('.custom-validation').length
    ) {
      $('body').removeClass('no-scroll');
      $('.gform_validation_errors').hide();
    }
  });

  $('.js-homepage-slider').slick({
    slidesToShow: 3,
    infinite: true,
    centerMode: true,
    centerPadding: '0px',
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    prevArrow:
      "<button type='button' class='slick-prev slick-arrow pull-left'><i class='fa fa-chevron-left' aria-hidden='true'></i></button>",
    nextArrow:
      "<button type='button' class='slick-next slick-arrow pull-right'><i class='fa fa-chevron-right' aria-hidden='true'></i></button>",
    rows: 0,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          // centerPadding: '10%',
        },
      },
    ],
  });
  $('.js-charters-slider').slick({
    slidesToShow: 3,
    infinite: true,
    centerMode: true,
    centerPadding: '0px',
    slidesToScroll: 1,
    autoplay: true,
    arrows: true,
    prevArrow:
      "<button type='button' class='slick-prev slick-arrow pull-left'><i class='fa fa-chevron-left' aria-hidden='true'></i></button>",
    nextArrow:
      "<button type='button' class='slick-next slick-arrow pull-right'><i class='fa fa-chevron-right' aria-hidden='true'></i></button>",
    rows: 0,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          // centerPadding: '10%',
        },
      },
    ],
  });
  let defaultFormat = 'dd/mm/yy';
  if (typeof gform !== 'undefined') {
    gform.addFilter('gform_repeater_item_pre_add', function (clone) {
      // do stuff
      return clone;
    });
    // response.country;
    $.get(
      'https://ipinfo.io',
      function (response) {
        if (response.country == 'US') {
          defaultFormat = 'mm/dd/yy';
        }
      },
      'jsonp'
    );
    gform.addFilter('gform_datepicker_options_pre_init', function (optionsObj) {
      // Apply to field 2 only
      // if ( fieldId == 2 ) {
      optionsObj.dateFormat = defaultFormat;
      optionsObj.minDate = 0;
      optionsObj.showOtherMonths = 1;
      optionsObj.selectOtherMonths = 1;
      optionsObj.changeMonth = 0;
      optionsObj.changeYear = 0;
      // }
      return optionsObj;
    });
  }
  $(document).on(
    'click',
    '.add_repeater_item.add_repeater_item_text',
    function () {
      let currAdd = $(this);
      setTimeout(function () {
        $(
          '.gfield_repeater_item .gfield_repeater_cell .ginput_container_date input'
        ).datepicker({
          // eslint-disable-line
          dateFormat: defaultFormat,
          autoclose: true,
          showOn: 'focus',
          minDate: new Date(),
          changeMonth: false,
          changeYear: false,
          suppressDatePicker: false,
          showOtherMonths: true,
          selectOtherMonths: true,
        });
        let date2 = currAdd
          .parents('.gfield_repeater_item')
          .find('.gfield_repeater_cell .ginput_container_date input')
          .datepicker('getDate');
        if (date2 !== null) {
          date2.setDate(date2.getDate() + 1);
          currAdd
            .parents('.gfield_repeater_item')
            .next()
            .find('.gfield_repeater_cell .ginput_container_date input')
            .datepicker('setDate', date2);
        }
        $('#ui-datepicker-div').addClass('gform-theme-datepicker');
        let repeater = true;
        initCustomSelect(repeater);
      }, 400);
    }
  );

  function fetch(element) {
    let query = element.val();
    $.ajax({
      url: `https://jetflo.com/wp-json/test/search?s=${query}`,
      type: 'get',
      beforeSend: function () {
        element
          .siblings('.search_result')
          .html(
            '<div class="search-results"><div id="loader" class="lds-dual-ring hidden overlay"></div></div>'
          );
        element
          .siblings('.search_result')
          .find('#loader')
          .removeClass('hidden');
      },
      success: function (data) {
        let output = '<div class="search-results">';
        output +=
          '<div id="loader" class="lds-dual-ring hidden overlay"></div>';
        if (data.prio.length) {
          output +=
            '<h5 class="search-results__heading">' +
            $('.footer').data('prio-text') +
            '</h5>';
        }
        $.each(data.prio, function (key, val) {
          output +=
            '<div class="searched-title" data-code="' + val.country_code + '">';
          if (Cookies.get('wp-wpml_current_language') == 'fr') {
            output +=
              '<p class="searched-title__value"><span class="fi fi-' +
              val.country_code.toLowerCase() +
              '"></span>' +
              '<span class="city">' +
              val.city_fr +
              '</span>' +
              ' - ' +
              val.name +
              '<span style="display: none"> ' +
              val.airportitata +
              '</span>' +
              '<span style="display: none"> ' +
              val.airporticao +
              '</span>' +
              '</p>';
          } else {
            output +=
              '<p class="searched-title__value"><span class="fi fi-' +
              val.country_code.toLowerCase() +
              '"></span>' +
              '<span class="city">' +
              val.city +
              '</span>' +
              ' - ' +
              val.name +
              '<span style="display: none"> ' +
              val.airportitata +
              '</span>' +
              '<span style="display: none"> ' +
              val.airporticao +
              '</span>' +
              '</p>';
          }
          output +=
            '<p class="searched-title__codes"><span>' +
            val.airportitata +
            '</span><span>' +
            val.airporticao +
            '</span></p>';
          output += '</div>';
        });
        output +=
          '<h5 class="search-results__heading">' +
          $('.footer').data('main-text') +
          '</h5>';
        $.each(data.main, function (key, val) {
          output +=
            '<div class="searched-title" data-code="' + val.country_code + '">';
          if (Cookies.get('wp-wpml_current_language') == 'fr') {
            output +=
              '<p class="searched-title__value"><span class="fi fi-' +
              val.country_code.toLowerCase() +
              '"></span>' +
              '<span class="city">' +
              val.city_fr +
              '</span>' +
              ' - ' +
              val.name +
              '<span style="display: none"> ' +
              val.airportitata +
              '</span>' +
              '<span style="display: none"> ' +
              val.airporticao +
              '</span>' +
              '</p>';
          } else {
            output +=
              '<p class="searched-title__value"><span class="fi fi-' +
              val.country_code.toLowerCase() +
              '"></span>' +
              '<span class="city">' +
              val.city +
              '</span>' +
              ' - ' +
              val.name +
              '<span style="display: none"> ' +
              val.airportitata +
              '</span>' +
              '<span style="display: none"> ' +
              val.airporticao +
              '</span>' +
              '</p>';
          }
          output +=
            '<p class="searched-title__codes"><span>' +
            val.airportitata +
            '</span><span>' +
            val.airporticao +
            '</span></p>';
          output += '</div>';
        });
        output += '</div>';
        element.siblings('.search_result').html(output);
      },
      complete: function () {
        element.siblings('.search_result').find('#loader').addClass('hidden');
      },
    }).fail(function (data) {
      console.log('data', data);
    });
  }

  function charters_fetch(element) {
    $.ajax({
      url: ajax_object.ajax_url,
      type: 'post',
      data: {
        action: 'charters_fetch',
        keyword: element.val(),
        term_id: $('.js-charters-wrap').data('term-id'),
      },
      // beforeSend: function () {
      //   // element
      //   //   .siblings('.search_result')
      //   //   .html(
      //   //     '<div class="search-results"><div id="loader" class="lds-dual-ring hidden overlay"></div></div>'
      //   //   );
      //   // $('#loader').removeClass('hidden');
      // },
      success: function (data) {
        $('.js-charters-wrap').html(data);
      },
      // complete: function () {
      //   // $('#loader').addClass('hidden');
      // },
    });
  }

  $('select.js-charter-types-pas').on('change', function () {
    charters_fetch($(this));
  });

  //START OF DESTINATIONS AJAX
  function destinations_fetch() {
    $.ajax({
      url: ajax_object.ajax_url,
      type: 'post',
      data: {
        action: 'destinations_fetch',
        keyword: $('.js-destinations-types-input').val(),
        term_id: $('.js-destinations-types-pas').val(),
      },
      success: function (data) {
        $('.js-destinations-wrap').html(data);
      },
    });
  }
  let destinationsTimer;
  $('input.js-destinations-types-input').on('keyup', function () {
    clearTimeout(destinationsTimer);
    destinationsTimer = setTimeout(function () {
      destinations_fetch();
    }, 500);
  });
  $('select.js-destinations-types-pas').on('change', function () {
    destinations_fetch();
  });
  $('.destinations-types-pas').on('click', function () {
    let defText = $(this).parent().find('select').data('def-text');
    $(this).text(defText);
    $(this).parent().find('li[rel="0"]').text(defText);
    $(this).parent().find('option[value="0"]').text(defText);
  });
  //END OF DESTINATIONS AJAX
  //START OF EVENTS AJAX
  function events_fetch() {
    $.ajax({
      url: ajax_object.ajax_url,
      type: 'post',
      data: {
        action: 'events_fetch',
        keyword: $('.js-events-types-input').val(),
        term_id: $('.js-events-types-pas').val(),
      },
      success: function (data) {
        $('.js-events-wrap').html(data);
      },
    });
  }
  let eventsTimer;
  $('input.js-events-types-input').on('keyup', function () {
    clearTimeout(eventsTimer);
    eventsTimer = setTimeout(function () {
      events_fetch();
    }, 500);
  });
  $('select.js-events-types-pas').on('change', function () {
    events_fetch();
  });
  //END OF EVENTS AJAX
  $(document).on('gform_post_render', function (event, form_id) {
    if (form_id === 1 || form_id === 6) {
      $(
        '.gfield_repeater_item .gfield_repeater_cell .ginput_container_text'
      ).each(function () {
        $(this).append(
          '<span class="removeClick">&times;</span><div class="search_result"></div>'
        );
      });
      let typingTimer;
      $(document).on(
        'keyup',
        '.gfield_repeater_item .gfield_repeater_cell .ginput_container_text input',
        function () {
          let el = $(this);
          clearTimeout(typingTimer);
          typingTimer = setTimeout(function () {
            fetch(el);
          }, 500);
          el.removeClass('clear-block');
        }
      );
      // $(
      //   '.gfield_repeater_item .gfield_repeater_cell .ginput_container_text input'
      // ).on('keyup', function () {
      // });
      $(document).on(
        'keyup',
        '.gfield_repeater_item .gfield_repeater_cell .ginput_container_text input',
        function () {
          if ($(this).val().length > 0) {
            $(this).siblings('.search_result').show();
            $(this).siblings('.removeClick').css('display', 'flex');
          } else {
            $(this).siblings('.search_result').hide();
            $(this).siblings('.removeClick').hide();
          }
        }
      );
      $(
        '.gfield_repeater_item .gfield_repeater_cell .ginput_container_text input'
      ).each(function () {
        if ($(this).val() != '') {
          $(this).addClass('clear-block');
        }
      });
      // $(
      //   '.gfield_repeater_item .gfield_repeater_cell .ginput_container_text input'
      // ).keyup(function () {
      // });
    } else if (form_id === 2 || form_id === 7) {
      $('.gform_button').on('click', function () {
        Cookies.set(
          'home-from',
          $('.gform_fields .gfield:eq(0)').find('input').attr('data-id')
        );
        Cookies.set(
          'home-to',
          $('.gform_fields .gfield:eq(1)').find('input').attr('data-id')
        );
      });
      $('.js-form-search .ginput_container_text').each(function () {
        $(this).append(
          '<span class="removeClick">&times;</span><div class="search_result"></div>'
        );
      });
      let typingTimer;
      $('.js-form-search .ginput_container_text input').on(
        'keyup',
        function () {
          let el = $(this);
          clearTimeout(typingTimer);
          typingTimer = setTimeout(function () {
            fetch(el);
          }, 500);
          el.removeClass('clear-block');
        }
      );
      $('.js-form-search .ginput_container_text input').keyup(function () {
        if ($(this).val().length > 0) {
          $(this).siblings('.search_result').show();
          $(this).siblings('.removeClick').css('display', 'flex');
        } else {
          $(this).siblings('.search_result').hide();
          $(this).siblings('.removeClick').hide();
        }
      });
      $('.js-form-search .ginput_container_text input').each(function () {
        if ($(this).val() != '') {
          $(this).addClass('clear-block');
        }
      });
    }
    // if (form_id === 1) {
    //   var x, y, top, left, down, target;
    //   if ($('.form-summary__destination').length) {
    //     $('.form-summary__destination').each(function () {
    //       let $this = $(this);
    //       $this.mousedown(function (e) {
    //         e.preventDefault();
    //         target = $(e.target);
    //         down = true;
    //         x = e.pageX;
    //         y = e.pageY;
    //         top = $(this).scrollTop();
    //         left = $(this).scrollLeft();
    //       });
    //
    //       $('body').mousemove(function (e) {
    //         if (down) {
    //           var newX = e.pageX;
    //           var newY = e.pageY;
    //
    //           //console.log(y+", "+newY+", "+top+", "+(top+(newY-y)));
    //           target.scrollTop(top - newY + y);
    //           target.scrollLeft(left - newX + x);
    //         }
    //       });
    //
    //       $('body').mouseup(function () {
    //         down = false;
    //       });
    //     });
    //   }
    // }
  });
  $(document).on('click', '.searched-title', function () {
    $(this)
      .parents('.ginput_container_text')
      .find('input')
      .addClass('clear-block');
    $(this)
      .parents('.ginput_container_text')
      .find('input')
      .attr('data-id', $(this).data('code'))
      .val($(this).children('.searched-title__value').text());
    Cookies.set(
      $(this).parents('.ginput_container_text').find('input').attr('id'),
      $(this).parents('.ginput_container_text').find('input').attr('data-id')
    );
    $(this).parent().hide();
    $(this)
      .parents('.search_result')
      .siblings('.removeClick')
      .css('display', 'flex');
    // $('.gfield_repeater_item .gfield_repeater_cell .ginput_container_text input');
  });
  $(document).on('click', ':not(.clear-block)', function () {
    $(
      '.home-contact-form .ginput_container_text input, .js-flight .ginput_container_text input'
    ).each(function () {
      if (!$(this).hasClass('clear-block')) {
        $(this).val('');
      }
    });
  });
  $(document).on('click', '.custom-validation .close', function () {
    $('body').removeClass('no-scroll');
    $('.gform_validation_errors').hide();
  });
  $(document).on('gform_post_render', function () {
    if (
      $('.gform_wrapper').hasClass('gform_validation_error') &&
      $('.gform_wrapper').length
    ) {
      window.scrollTo(0, $('.custom-validation__wrapper').offset().top);
      $('body').addClass('no-scroll');
    }
    $('.ginput_container_date input').attr('readonly', 'readonly');
    $('.form-summary .gform_previous_button').on('click', function () {
      Cookies.set('Item-number', $(this).data('item'));
    });
  });
  $(document).on('gform_page_loaded', function (event, form_id, current_page) {
    if (current_page == 1) {
      let currNumber = Cookies.get('Item-number');
      let scrollTo;
      let position;
      if (currNumber && currNumber !== 'undefined') {
        scrollTo = $('.gfield_repeater_item:eq(' + currNumber + ')');
        position = scrollTo.offset().top - $('header').innerHeight() - 50;
        $('html, body').animate(
          {
            scrollTop: position,
          },
          400
        );
      }
      Cookies.remove('Item-number');

      setTimeout(function () {
        $(
          '.gfield_repeater_item .gfield_repeater_cell .ginput_container_text input'
        ).each(function () {
          $(this).siblings('.removeClick').css('display', 'flex');
        });
      }, 500);
    }
  });
  $(document).on('click', '.removeClick', function () {
    $(this).siblings('input').val('').removeClass('clear-block');
    $(this).siblings('.search_result').hide();
    $(this).hide();
  });
  $(document).on('click', '.js-m-collapse', function () {
    if ($(this).hasClass('active')) {
      $('.js-m-collapse').each(function () {
        $(this).parent().removeClass('opaque');
      });
      $(this).removeClass('active');
    } else {
      $('.js-m-collapse').each(function () {
        $(this).parent().addClass('opaque');
      });
      $(this).parent().removeClass('opaque');
      $(this).addClass('active');
    }
  });
  $(document).on('click', '.js-desk-collapse', function () {
    if ($(this).hasClass('active')) {
      $('.js-desk-collapse').each(function () {
        $(this).parent().removeClass('opaque');
      });
      $(this).removeClass('active');
    } else {
      $('.js-desk-collapse').each(function () {
        $(this).parent().addClass('opaque');
        $(this).removeClass('active');
      });
      $(this).parent().removeClass('opaque');
      $(this).addClass('active');
    }
  });
  if ($('.browser-lang').length) {
    let originalString = window.navigator.language;
    originalString = originalString.split('-')[0];
    $('.browser-lang input').val(originalString.toUpperCase());
  }
  // $(document).on('click', '.add_repeater_item', function () {
  //   $('.remove_repeater_item').attr('onclick', 'gformDeleteRepeaterItem(this)');
  // });
  $(document).on('click', '.js-prev-remove', function () {
    if ($('.js-prev-remove').length > 1) {
      $('.js-prev-remove').preventDefault();
    }
  });
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  // jQuery code goes here

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // jQuery code goes here

  resizeVideo();
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function () {
  // jQuery code goes here
});
